import CryptoJS from "crypto-js"
const locaLStorageSecret = process.env.REACT_APP_STARDUST_CACHING_SECRET
export class LocalStorageHandler {
	static expirationPeriod = 86400 // It will expire after one day.
	static saveData(key: string, value: any, encrypted?: boolean) {
		const expiresDate = new Date().getTime() + LocalStorageHandler.expirationPeriod
		const secretKey = CryptoJS.SHA256(key + locaLStorageSecret).toString()
		let data
		if (encrypted) {
			data = CryptoJS.AES.encrypt(
				JSON.stringify({expiresAt: expiresDate, value: value}),
				secretKey
			).toString()
		} else {
			data = JSON.stringify({expiresAt: expiresDate, value: value})
		}
		localStorage.setItem(secretKey, data)
	}
	static getData(key: string, encrypted?: boolean) {
		const secretKey = CryptoJS.SHA256(key + locaLStorageSecret).toString()
		let storedData: string | null | any = localStorage.getItem(secretKey)
		if (!storedData) return null
		if (encrypted) {
			var bytes = CryptoJS.AES.decrypt(storedData, secretKey)
			storedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
		} else {
			storedData = JSON.parse(storedData)
		}
		const currentDate = new Date().getTime()
		if (currentDate < storedData.expiresAt) {
			// session not expired
			return storedData.value
		} else {
			localStorage.removeItem(key)
			return null
		}
	}
}
